import { useResizeListener } from '@shared/Frontend/hooks/useResizeListener'
import { breakpointSiteheader, getBreakpoint } from '@shared/Frontend/utils/breakpoints'
import { fieldReplacer, fieldUpdater } from '@shared/Frontend/utils/updaters'
import { List } from 'immutable'
import {
  AsyncState,
  HttpResult,
  Option,
  StandardLocalWidget,
  Updater,
  any,
  async,
  fromJSX,
  loadedAsyncState,
  loadingAsyncState,
  none,
  nothing,
  onlyIf,
  router,
  some,
  then,
  unloadedAsyncState
} from 'widgets-for-react'
import { cookiebar } from '../legacy/public_site/components/cms/blocks/cookiebar/cookiebar.widget.mod'
import { parse_menu } from '../legacy/public_site/components/drupal/api/api.mod'
import { MenuItem, ParsedMenuItem } from '../legacy/public_site/components/drupal/types_and_parser/extra_types.mod'
import { BatchRequestResponse, performBatchRequest } from '../legacy/public_site/components/http_batch'
import { extracted_batch, inert } from '../legacy/public_site/components/public_site/application.mod'
import { page } from '../legacy/public_site/components/public_site/templates/drupal_page.mod'
import { footer } from '../legacy/public_site/components/public_site/templates/footer.mod'
import { removeBoldsAndSplitsButLastSplit } from '../legacy/public_site/components/public_site/utils/helpers'
import { getLangFromUrl, updateUrlLang } from '../legacy/public_site/components/public_site/utils/history.mod'
import { Use } from '../legacy/public_site/components/public_site/utils/use'
import { serverRedirectWidget } from '../legacy/public_site/custom_components/serverRedirect.widget'
import { siteheaderWidget } from './siteheader/siteheader.widget'
import { PublicSiteState, RootState } from './state'
import { pages } from './utils'
import React = require('react')

export const rootWidget =
  (language: string): StandardLocalWidget<RootState> =>
  (s0) =>
    any<Updater<RootState>>([
      fromJSX((setState) => (
        <Use
          use={() => {
            useResizeListener(() => {
              setState((state) =>
                fieldUpdater<RootState>()('state')(fieldReplacer<PublicSiteState>()('breakpoint')(getBreakpoint()))(
                  fieldUpdater<RootState>()('state')(
                    fieldReplacer<PublicSiteState>()('viewportWidth')(window.innerWidth)
                  )(state)
                )
              )
            })
          }}
        />
      )),

      // stateful<FormState>(null)(s => Form(s).map<FormState>(a => a(s)))(
      //   getFormStateMonitorCampaign("27ce8fb403dc05b25ed767f7490f3efc")
      // ).never(),

      serverRedirectWidget(s0.state.serverRedirectState).map(
        then(fieldUpdater<PublicSiteState>()('serverRedirectState'), fieldUpdater<RootState>()('state'))
      ),

      s0.state.batch_get_header_footer.kind == 'unloaded'
        ? fromJSX((setState) => {
            const batch_get_header_footer: AsyncState<BatchRequestResponse[]> = loadingAsyncState(
              () =>
                new Promise<HttpResult<BatchRequestResponse[]>>((res, _) => {
                  if (is_batch_call_running) return res({ kind: 'unauthorized', status: 400 })
                  is_batch_call_running = true
                  const localePart = `/${language}`
                  performBatchRequest([
                    {
                      requests: [
                        {
                          method: 'GET',
                          path: `/api/drupal${localePart}/api/menu_items/main`,
                          requestId: 'header'
                        },
                        {
                          method: 'GET',
                          path: `/api/drupal${localePart}/api/menu_items/footer`,
                          requestId: 'footer'
                        },
                        {
                          method: 'GET',
                          path: `/api/drupal${localePart}/api/menu_items/main`,
                          requestId: 'top_menu'
                        },
                        {
                          method: 'GET',
                          path: `/api/drupal${localePart}/api/menu_items/footer`,
                          requestId: 'privacy_menu'
                        },
                        {
                          method: 'GET',
                          path: `/api/v1/peoplexs/vacancies`,
                          requestId: 'vacancies'
                        }
                      ],
                      success: async (res) => {
                        setState((s) => {
                          const s1 = { ...s }

                          const header_req = res.find((r) => r.requestId == 'header')
                          if (header_req && header_req.data.kind == 'result') {
                            const header_list: Array<ParsedMenuItem> = parse_menu(JSON.parse(header_req.data.value))
                            s1.state.siteheader.navLinks = loadedAsyncState(header_list)
                          }

                          const footer_req = res.find((r) => r.requestId == 'footer')
                          if (footer_req && footer_req.data.kind == 'result') {
                            let menuItems = JSON.parse(footer_req.data.value)
                            menuItems = localizeMenu(menuItems, language)
                            const footer_list: Array<ParsedMenuItem> = parse_menu(menuItems)
                            s1.state.footer.cols = loadedAsyncState(footer_list)
                            let footer_elems = parse_footer_menu3(footer_list)
                            s1.state.footer.col_1 = footer_elems.col1
                            s1.state.footer.col_2 = footer_elems.col2
                            s1.state.footer.col_3 = footer_elems.col3
                          }

                          const privacy_menu_req = res.find((r) => r.requestId == 'privacy_menu')
                          if (privacy_menu_req && privacy_menu_req.data.kind == 'result') {
                            const privacy_menu_list: Array<ParsedMenuItem> = parse_menu(
                              JSON.parse(privacy_menu_req.data.value)
                            )
                            s1.state.footer.privacyMenu = loadedAsyncState(privacy_menu_list)
                          }

                          return s1
                        })
                      },
                      error: async (res) => {
                        setState((s) => {
                          return extracted_batch(s, res, false, language)
                          // const s1 = { ...s }

                          // const headerReq = res.find((r) => r.requestId == 'header')
                          // if (headerReq && headerReq.data.kind == 'result') {
                          //   const headerList: List<ParsedMenuItem> = parse_menu(
                          //     JSON.parse(headerReq.data.value)
                          //   )
                          //   s1.state.header.menuHeader.navLinks = {
                          //     kind: 'loaded',
                          //     value: headerList,
                          //     cache: { kind: 'empty' }
                          //   }
                          // } else {
                          //   s1.state.header.menuHeader.navLinks = loadingAsyncState(() => Api.loadHeader(lang))
                          // }

                          // const footerReq = res.find((r) => r.requestId == 'footer')
                          // if (footerReq && footerReq.data.kind == 'result') {
                          //   const footerList: List<ParsedMenuItem> = parse_menu(
                          //     JSON.parse(footerReq.data.value)
                          //   )
                          //   s1.state.footer.cols = {
                          //     kind: 'loaded',
                          //     value: footerList,
                          //     cache: { kind: 'empty' }
                          //   }
                          // } else {
                          //   s1.state.footer.cols = loadingAsyncState(() => Api.loadFooterColumn(lang, 1))
                          // }

                          // // const languages_req = res.find((r) => r.requestId == 'languages')
                          // // if (languages_req && languages_req.data.kind != 'result') {
                          // //   s1.state.header.menuHeader.languages = loadingAsyncState(() => Api.loadLanguages())
                          // // }

                          // const top_menu_req = res.find((r) => r.requestId == 'top_menu')
                          // if (top_menu_req && top_menu_req.data.kind != 'result') {
                          //   s1.state.header.topMenu = loadingAsyncState(() => loadTopMenu(lang))
                          // }

                          // const country_menu_req = res.find((r) => r.requestId == 'top_menu')
                          // if (country_menu_req && country_menu_req.data.kind != 'result') {
                          //   s1.state.header.countryMenu = loadingAsyncState(() => loadCountryMenu(lang))
                          // }

                          // const privacy_menu_req = res.find((r) => r.requestId == 'privacy_menu')
                          // if (privacy_menu_req && privacy_menu_req.data.kind != 'result') {
                          //   s1.state.footer.privacyMenu = loadingAsyncState(() => loadPrivacyMenu(lang))
                          // }

                          // const vacancies_req = res.find((r) => r.requestId == 'vacancies')
                          // if (vacancies_req && vacancies_req.data.kind != 'result') {
                          //   s1.state.footer.new_vacancies = loadingAsyncState(() => loadVacancies(lang, "", [], []).then(r => r.kind == "result" ? { ...r, value: r.value.take(3).toList() } : r))
                          // }

                          // return s1
                        })
                      }
                    }
                  ])
                    .then((_res) => res({ kind: 'result', status: 200, value: _res }))
                    .catch((e) => {
                      setState((s) => extracted_batch(s, [], true, language))
                      //Disable the log for now since we are bypassing the batch
                      // console.log('Error calling batch', e)
                      res({ kind: 'result', status: 200, value: [] })
                    })
                })
            )
            setState((s): RootState => ({ ...s, state: { ...s.state, batch_get_header_footer } }))
            return null
          })
        : nothing(),

      async(s0.state.batch_get_header_footer).map(
        (a) =>
          (s1): RootState => ({
            ...s1,
            state: { ...s1.state, batch_get_header_footer: a(s1.state.batch_get_header_footer) }
          })
      ),

      async(s0.state.siteheader.navLinks).map(
        (a) =>
          (s1): RootState => ({
            ...s1,
            state: { ...s1.state, siteheader: { ...s1.state.siteheader, navLinks: a(s1.state.siteheader.navLinks) } }
          })
      ),

      async(s0.state.footer.cols).map((a) => (s1): RootState => {
        let res = a(s1.state.footer.cols)

        let s2 = {
          ...s1,
          state: {
            ...s1.state,
            footer: {
              ...s1.state.footer,
              cols: res
            }
          }
        }

        if (res.kind == 'loaded') {
          let footer_elems = parse_footer_menu3(res.value)
          s2.state.footer.col_1 = footer_elems.col1
          s2.state.footer.col_2 = footer_elems.col2
          s2.state.footer.col_3 = footer_elems.col3
        }

        return s2
      }),

      async(s0.state.footer.privacyMenu).map(
        (a) =>
          (s1): RootState => ({
            ...s1,
            state: {
              ...s1.state,
              footer: {
                ...s1.state.footer,
                privacyMenu: a(s1.state.footer.privacyMenu)
              }
            }
          })
      ),

      async(s0.state.footer.footerImage).map(
        (a) =>
          (s1): RootState => ({
            ...s1,
            state: {
              ...s1.state,
              footer: {
                ...s1.state.footer,
                footerImage: a(s1.state.footer.footerImage)
              }
            }
          })
      ),

      s0.state.page.page.kind == 'loaded' && s0.state.page.page.value.extra_data.node.bundle != 'homepage'
        ? async(s0.state.page.page.value.extra_data.breadcrumb).map((a) => (s1): RootState => {
            if (s1.state.page.page.kind == 'loaded') {
              const a1 = a(s1.state.page.page.value.extra_data.breadcrumb)

              s1 = {
                ...s1,
                state: {
                  ...s1.state,
                  page: {
                    ...s1.state.page,
                    display: page(none()),
                    page: {
                      ...s1.state.page.page,
                      value: {
                        ...s1.state.page.page.value,
                        extra_data: {
                          ...s1.state.page.page.value.extra_data,
                          breadcrumb: a1
                        }
                      }
                    }
                  }
                }
              }
            }
            return s1
          })
        : nothing(),

      onlyIf(
        s0.page.kind != 'styleguide',
        cookiebar(s0.state.cookiestate).map(
          (a) =>
            (s): RootState => ({ ...s, state: { ...s.state, cookiestate: a(s.state.cookiestate) } })
        )
      ),

      s0.page.kind == 'styleguide'
        ? nothing()
        : siteheaderWidget(
            s0.state.siteheader,
            breakpointSiteheader(s0.state.breakpoint),
            language,
            s0.page.kind == 'update_overview'
              ? s0.state.update_overview.state.page.page.kind == 'loaded'
                ? s0.state.update_overview.state.page.page.value.extra_data.node
                : 'none'
              : s0.state.page.page.kind == 'loaded'
              ? s0.state.page.page.value.extra_data.node
              : 'none'
          ).map(
            (a) =>
              (s1): RootState => ({ ...s1, state: { ...s1.state, siteheader: a(s1.state.siteheader) } })
          ),

      s0.current_widget.kind == 'r'
        ? s0.current_widget.v(s0.state).map(
            (a) =>
              (s1): RootState => ({ ...s1, state: a(s1.state) })
          )
        : nothing(),

      router<Updater<RootState>>()(pages).map((updater) => (state): RootState => {
        let s1 = updater(state)
        if (state.state.page.page.kind != 'loaded' && s1.state.page.page.kind == 'loaded')
          s1 = { ...s1, state: { ...s1.state, page: { ...s1.state.page, display: page(none()) } } }
        return s1
      }),

      fromJSX((setState) =>
        onlyIf(
          s0.page.kind != 'styleguide',
          footer(
            s0.state.footer,
            () =>
              setState((s) => ({
                ...s,
                state: {
                  ...s.state,
                  cookiestate: {
                    ...s.state.cookiestate,
                    CookieBarVisible: true
                  }
                }
              })),
            inert(s0.state)
          ).map(
            (a) =>
              (s1: RootState): RootState => ({
                ...s1,
                state: { ...s1.state, footer: a(s1.state.footer) }
              })
          )
        ).run(setState)
      )
    ]).map((a) => (s0): RootState => {
      const s1 = a(s0)
      const lang = getLangFromUrl()
      if (language != lang) {
        s1.state.batch_get_header_footer = unloadedAsyncState()
      }
      s1.state.page.page.kind == 'loaded' &&
        (window.document.title = removeBoldsAndSplitsButLastSplit(
          s1.state.page.page.value.extra_data.node.metatag.title
        ))

      if (s1.page != s0.page) {
        s1.state.siteheader.mode = 'closed'
        window.scrollTo(0, 0)
      }

      return s1
    })

let is_batch_call_running = false

let parse_footer_menu3 = (
  items: Array<ParsedMenuItem>
): {
  col1: Option<ParsedMenuItem>
  col2: Option<ParsedMenuItem>
  col3: Option<ParsedMenuItem>
} => {
  let res = {
    0: none<ParsedMenuItem>(),
    1: none<ParsedMenuItem>(),
    2: none<ParsedMenuItem>()
  }

  items.map((element, i) => {
    res[i] = some<ParsedMenuItem>(element)
  })

  return {
    col1: res[0],
    col2: res[1],
    col3: res[2]
  }
}

const localizeMenu = (menuItems: MenuItem[], newLang: string): Array<MenuItem> =>
  menuItems.map(
    (i): MenuItem => ({
      ...i,
      relative: i.relative ? updateUrlLang(i.relative, newLang) : i.relative,
      below: i.below ? localizeMenu(i.below, newLang) : i.below
    })
  )
